

















import { defineComponent } from "@vue/composition-api"

// hooks
import useRechargeAgreement from "./useRechargeAgreement"
import useLocation from "../useLocation"

export default defineComponent({
  setup() {
    const rechargeAgreement = useRechargeAgreement()
    const location = useLocation()
    return {
      ...rechargeAgreement,
      ...location
    }
  }
})
